import { ProductPageModel } from 'models/ProductPageModel';
import connect from 'components/Shared/connect';
import { ProductListView } from 'views/ProductPage/productListView';
import { getRecommended } from 'views/ProductPage/selector';
import { ProductSection } from './sections/productSection';
import { rm, NO_ELEMENT, hasElements } from 'utils';

interface OwnProps {
  className?: string;
}

type MergedProps = OwnProps & Pick<ProductPageModel, 'recommended'>;

const _Recommended = ({ recommended = [] }) => {
  const hasRecommended = hasElements(recommended);

  if (!hasRecommended) {
    return NO_ELEMENT;
  }

  return (
    <ProductSection title={rm('product_recommended')}>
      <ProductListView products={recommended} />
    </ProductSection>
  );
};

export const Recommended = connect<MergedProps, OwnProps>(state => ({
  recommended: getRecommended(state.currentPage)
}))(_Recommended);
